"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerMovementComponent = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class PlayerMovementComponent extends gotti_1.Component {
    constructor(speed) {
        super(Constants_1.SYSTEMS.PLAYER_MOVEMENT);
        this.lookingDirection = 'south';
        this.velocityX = 0;
        this.velocityY = 0;
        this.disabled = true;
        this.speed = speed;
    }
    onAdded(entity) {
    }
    get isSprinting() {
        return Math.abs(this.velocityX) > this.speed || Math.abs(this.velocityY) > this.speed;
    }
    setVelocities(x, y) {
        this.velocityX = x;
        this.velocityY = y;
    }
    get movingDirection() {
        if (this.velocityX != 0) {
            if (this.velocityX > 0)
                return 'east';
            return 'west';
        }
        else if (this.velocityY != 0) {
            if (this.velocityY > 0)
                return 'south';
            return 'north';
        }
        return null;
    }
}
exports.PlayerMovementComponent = PlayerMovementComponent;
//# sourceMappingURL=module.js.map